// extracted by mini-css-extract-plugin
export default {"title":"Paper_title__Kf8wF","root":"Paper_root__nQdKy","documentsToBeSigned":"Paper_documentsToBeSigned__+GoUE","blink":"Paper_blink__WX0Kq"};